import { render, staticRenderFns } from "./gesamtbewertung_a4.vue?vue&type=template&id=0f33650c&scoped=true"
import script from "./gesamtbewertung_a4.vue?vue&type=script&lang=js"
export * from "./gesamtbewertung_a4.vue?vue&type=script&lang=js"
import style0 from "./gesamtbewertung_a4.vue?vue&type=style&index=0&id=0f33650c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f33650c",
  null
  
)

export default component.exports